import { action, computed, makeObservable, observable } from "mobx";
import { FieldType, ViewModelBase } from "@shoothill/core";
import { APIClient, RelayCommand } from "Application";
import { StudentSessionBehaviourModel, StudentSessionBehaviourModelValidator } from "./StudentSessionBehaviourModel";

export class StudentSessionBehaviourViewModel extends ViewModelBase<StudentSessionBehaviourModel> {
    public apiClient = new APIClient();

    public _showScoreError: boolean = false;

    constructor(model: StudentSessionBehaviourModel) {
        super(model);
        this.setValidator(new StudentSessionBehaviourModelValidator());
        makeObservable(this, {
            _showScoreError: observable,
            showScoreError: computed,
            setShowScoreError: action,
            validateModel: action,
        });
    }

    public get showScoreError(): boolean {
        return this._showScoreError;
    }

    public onScoreBlurCommand = new RelayCommand(() => {
        this.validateModel();
    });

    public updateScoreCommand = new RelayCommand((v: any) => {
        this.updateField("score", v);
        this.validateModel();
    });

    private updateField = (fieldName: keyof FieldType<StudentSessionBehaviourModel>, value: any) => {
        this.setValue(fieldName, value);
        this.isFieldValid(fieldName);
    };

    public setShowScoreError = (value: boolean) => {
        this._showScoreError = value;
    };

    public validateModel = () => {
        //validate
        this.isFieldValid("score");
        //get errors
        const isScoreValid: string | undefined = this.getError("score");
        ///set ui errors
        this.setShowScoreError(isScoreValid != undefined);
    };
}
